import HttpCliente from '../HttpCliente';

// NUEVAS FUNCIONES PARA VIDEO STREAM
export const getVideoStreamUrl = (videoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/VideoStream/video/${videoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message || "Error al obtener URL del video");
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión al obtener video";
            reject(errorMessage);
        });
    });
};

export const getThumbnailStreamUrl = (videoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/VideoStream/thumbnail/${videoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message || "Error al obtener thumbnail");
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión al obtener thumbnail";
            reject(errorMessage);
        });
    });
};

export const incrementVideoView = (videoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post(`/VideoStream/increment-view/${videoId}`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message || "Error al incrementar vista");
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene la lista de Series
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getShowsEstreno = (setSeries, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/estrenos", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSeries(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * GET method - Obtiene la lista de Series
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getGaleriaVideos = (setSeries, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/galeria", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSeries(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * GET method - Obtiene informacion de un VideoShow por ID
 * @param {string} id - ID del VideoShow
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getVideoShowById = (id, setCapitulo, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/VideoShows/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setCapitulo(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene la lista de Series destacadas
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getShowsDestacados = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/destacados", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getTagsStandup = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/tagstandup", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getShowsHumorNegro = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/tagHumorNegro", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getHumorAbsurdo = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/tagHumorAbsurdo", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getTopMasVistos = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/topmasvistos", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getReels = (setShows, setError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/reels", {
            headers: {
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

// FUNCIONES PARA ADMIN (CRUD)
export const getVideoShowsPaginados = (setSuccess, setError, pageNumber = 1, pageSize = 10, searchTerm = '', token) => {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams({
            pageNumber: pageNumber.toString(),
            pageSize: pageSize.toString()
        });
        
        if (searchTerm) {
            params.append('searchTerm', searchTerm);
        }

        HttpCliente.get(`/VideoShows/paged?${params.toString()}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSuccess(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

export const createVideoShow = (videoShowData, setError, token) => {
    return new Promise((resolve, reject) => {
        let requestOptions;
        
        // Si videoShowData es FormData (archivos), usar esa configuración
        if (videoShowData instanceof FormData) {
            requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                    // No agregar Content-Type para FormData
                },
                body: videoShowData
            };
        } else {
            // Para datos JSON normales
            requestOptions = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            };
        }

        if (videoShowData instanceof FormData) {
            // Usar fetch directamente para FormData
            fetch('/api/VideoShows', requestOptions)
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(text);
                    });
                }
                return response.json();
            })
            .then(data => {
                resolve(data);
            })
            .catch(error => {
                setError(error.message);
                reject(error.message);
            });
        } else {
            // Usar HttpCliente para JSON
            HttpCliente.post("/VideoShows", videoShowData, requestOptions)
            .then(response => {
                if (response.status === 201 || response.status === 200) {
                    resolve(response.data);
                } else {
                    setError(response.data.message);
                    reject(response.data.message);
                }
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || "Error al crear el video";
                setError(errorMessage);
                reject(errorMessage);
            });
        }
    });
};

export const updateVideoShow = (id, videoShowData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/VideoShows/${id}`, videoShowData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al actualizar el video";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

export const deleteVideoShow = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/VideoShows/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 204 || response.status === 200) {
                resolve(true);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al eliminar el video";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

export const rateVideo = (videoId, isLike, comentario, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post(`/VideoStream/rate/${videoId}`, 
            { 
                isLike: isLike,
                comentario: comentario 
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            }
        )
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message || "Error al calificar el video");
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión al calificar";
            reject(errorMessage);
        });
    });
};

export const removeRating = (videoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/VideoStream/rate/${videoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message || "Error al eliminar calificación");
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            reject(errorMessage);
        });
    });
};

export const getMyRating = (videoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/VideoStream/rate/${videoId}/my-rating`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message || "Error al obtener calificación");
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            reject(errorMessage);
        });
    });
};